import { render, staticRenderFns } from "./CommonHeaderGame.vue?vue&type=template&id=150cf48e&scoped=true&"
import script from "./CommonHeaderGame.vue?vue&type=script&lang=ts&"
export * from "./CommonHeaderGame.vue?vue&type=script&lang=ts&"
import style0 from "./CommonHeaderGame.vue?vue&type=style&index=0&id=150cf48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150cf48e",
  null
  
)

export default component.exports